var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"phone-wrapper"},[(_setup.showImage)?_c('img',{attrs:{"src":require("@/assets/img/iframe.png")}}):_vm._e(),_vm._v(" "),(_vm.visible)?_c('iframe',{ref:"iframeRef",attrs:{"src":_setup.url,"frameborder":"0","id":"iframe","sandbox":"allow-scripts allow-same-origin allow-forms"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }